module.exports = __webpack_public_path__ + "img/telegram_logo.404fe09d.png";